module.exports = __webpack_public_path__ + "img/icon_map_2_5_hg.07aef9da.png";